import React from 'react';
import { useTranslation } from 'react-i18next';
import { DashboardLayout, CompanyInviteWidget } from '../components';
import { Breadcrumb } from '../components/Breadcrumb';

export function PersonInvite() {
  const { t } = useTranslation();

  return (
    <DashboardLayout>
      <div className="page-header mb-4">
        <div className="page-header-left d-flex align-items-center">
          <div className="page-header-title">
            <h5 className="fw-bold mb-0">{t('personHome.invite.title')}</h5>
          </div>
          <Breadcrumb items={[
            { label: t('nav.home'), path: '/home' },
            { label: t('personHome.invite.title') }
          ]} />
        </div>
      </div>

      <CompanyInviteWidget className="mb-4" showIntro />
    </DashboardLayout>
  );
}
